module.exports = __webpack_public_path__ + "img/T1D_rc-1.91e94ab0.png";